import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Drawer, Divider, Select } from 'antd';
import { isMobile } from 'react-device-detect';
import CKEditorComponent from '../../components/Editor/CKEditorComponent';
import { _newLine } from '../../utils/helpers';
import { createScheduleJob, updateScheduleJob } from '../../redux/actions/scheduleJobActions';

class ScheduleJobForm extends Component {
    state = { isLoading: false };

    submit = event => {
        event.preventDefault();
        this.props.form.validateFields((error, values) => {
            if (error) return;

            const request = this.props.currentData
                ? this.props.updateScheduleJob(this.props.currentData.id, values)
                : this.props.createScheduleJob(values);

            this.setState({ isLoading: true });
            request
                .then(() => {
                    this.props.reloadData();
                    this.close();
                })
                .catch(() => null)
                .finally(() => this.setState({ isLoading: false }));
        });
    };

    close = () => {
        this.props.form.resetFields();
        this.props.onCancel();
    };

    render() {
        const { visible, currentData, config, authUser } = this.props;
        const { getFieldDecorator } = this.props.form;
        const currentRoleId = currentData?.role_id || authUser?.role_id;
        const isAdmin = authUser?.role_code === 'ADMIN';

        return (
            <Drawer
                visible={visible}
                title={currentData ? 'Sửa công việc' : 'Thêm công việc'}
                onClose={this.close}
                maskClosable={false}
                width={isMobile ? '100%' : '45%'}
                footer={(
                    <div style={{ textAlign: 'right' }}>
                        <Button onClick={this.close}>Huỷ</Button>
                        <Divider type="vertical" />
                        <Button type="primary" loading={this.state.isLoading} onClick={this.submit}>
                            {currentData ? 'Cập nhật' : 'Tạo'}
                        </Button>
                    </div>
                )}
            >
                {visible ? (
                    <Form layout="vertical">
                        <Form.Item label="Vai trò công việc">
                            {getFieldDecorator('role_id', {
                                rules: [{ required: true, message: 'Vui lòng chọn vai trò.' }],
                                initialValue: currentRoleId ? Number(currentRoleId) : null
                            })(
                                <Select
                                    className="w-100"
                                    placeholder="Chọn vai trò"
                                    options={config.role_trees || []}
                                    disabled={!isAdmin}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Mô tả công việc">
                            {getFieldDecorator('description', {
                                rules: [{ required: true, message: 'Vui lòng nhập mô tả công việc.' }],
                                initialValue: currentData?.description || ''
                            })(
                                <CKEditorComponent
                                    initialHeight="300px"
                                    editorData={currentData?.description}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Ghi chú">
                            {getFieldDecorator('note', {
                                initialValue: currentData ? _newLine(currentData.note) : ''
                            })(<Input.TextArea rows={3} />)}
                        </Form.Item>
                    </Form>
                ) : null}
            </Drawer>
        );
    }
}

const mapStateToProps = state => ({ config: state.config, authUser: state.auth.authUser });
const mapDispatchToProps = dispatch => ({
    createScheduleJob: data => dispatch(createScheduleJob(data)),
    updateScheduleJob: (id, data) => dispatch(updateScheduleJob(id, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ScheduleJobForm' })(ScheduleJobForm));
